import { getSummerHost } from "../config/env";
import RouterConstants from "./RouterConstants";

class LinkConstants {
	public static readonly BRIA_WEBSITE: string = "https://bria.ai/";
	public static readonly PRIVACY_POLICY: string = "https://bria.ai/privacy-policy";
	public static readonly LEGAL_LOBBY: string = "https://bria.ai/legal-lobby";
	public static readonly BRIA_API: string = "https://docs.bria.ai";
	public static readonly CONTENT_MODERATION_BRIA_API_DOC: string =
		"https://docs.bria.ai/safety#input--output-visual-moderation";
	public static readonly PROMPT_MODERATION_BRIA_API_DOC: string = "https://docs.bria.ai/safety#prompt-moderation";
	public static readonly IP_SIGNAL_BRIA_API_DOC: string = "https://docs.bria.ai/safety#handling-ip-related-prompts";
	public static readonly IFRAME_DOCS: string = "https://github.com/Bria-AI/iframe-doc";
	public static readonly IFRAME_v2_DOCS: string = "https://github.com/Bria-AI/iframe-doc/tree/iframe-v2";
	public static readonly CONTACT_US_FORM_LINK: string = "https://bria.ai/contact-us";
	public static readonly TERMS_AND_CONDITIONS_LINK: string = "https://bria.ai/terms-and-conditions/";
	public static readonly LEGAL_LOBBY_LINK: string = "https://bria.ai/legal-lobby";
	public static readonly PRESENTER_RECASTING: string = `${getSummerHost()}/gallery/ade0c69399697896?selectedTab=presenters`;
	public static readonly STATUS_PAGE: string = "https://status.bria.ai/";
	public static readonly DISCORD_COMMUNITY: string = "https://discord.gg/Nxe9YW9zHS";
	public static readonly SLACK_API_COMMUNITY: string =
		"https://join.slack.com/t/briaapi/shared_invite/zt-2urw5ppmc-4K8hxWLQ1wYLvekB66zm7A";
	public static readonly BRIA_HUGGING_FACE: string = "https://huggingface.co/briaai";
	public static readonly BRIA_AGENT: string = "https://github.com/Bria-AI/agent";
	public static readonly AI_EDITOR: string = `${getSummerHost()}/gallery/8679a552aa79cc96/?from_platform_hub=true&openUploadPopup=true`;
	public static readonly BRIA_IMAGES_URL: string = "https://images.bria.ai/";
	public static readonly BRIA_USER_ASSETS_CLOUDFRONT: string = "https://user-assets.bria.ai/";
	public static readonly BRIA_ORG_ASSETS_CLOUDFRONT: string = "https://org-assets.bria.ai/";
	public static readonly BRIA_AI_AWS_MARKETPLACE: string = `https://aws.amazon.com/marketplace/seller-profile?id=seller-ilfk2fw5juhfi`;
	public static readonly BRIA_AI_AZURE_MARKETPLACE: string =
		"https://azuremarketplace.microsoft.com/en-us/marketplace/apps/briaartificialintelligenceltd1704805814390.bria_image_generation_model_offer?tab=Overview";
	public static readonly BRIA_HF_PRODUCT_SHOT_GEN: string =
		"https://huggingface.co/spaces/briaai/Product-Shot-Generation";
	public static readonly BRIA_FAL_AI: string = "https://fal.ai/models?keywords=bria";
	public static readonly REPLICATE: string = "https://replicate.com/bria";
	public static readonly INVOKE_PLATFORM: string = "https://www.invoke.com/";
	// ComfyUI
	public static readonly BRIA_COMFYUI_API: string = "https://github.com/Bria-AI/ComfyUI-BRIA-API";
	public static readonly BRIA_COMFYUI_TAILORED_GEN: string = `${this.BRIA_COMFYUI_API}/tree/main?tab=readme-ov-file#tailored-generation-nodes`;
	// Image Generation
	public static readonly BRIA_API_TEXT_TO_IMAGE: string = `${this.BRIA_API}/image-generation/endpoints/text-to-image-base`;
	public static readonly BRIA_API_TEXT_TO_VECTOR: string = `${this.BRIA_API}/image-generation/endpoints/text-to-vector-base`;
	public static readonly BRIA_API_IMAGE_REFERENCE: string = `${this.BRIA_API}/image-generation/endpoints/reimagine-structure-reference`;
	public static readonly BRIA_API_PROMPT_ENHANCE: string = `${this.BRIA_API}/image-generation/endpoints/prompt-enhancer`;
	// Tailored Generation
	public static readonly BRIA_API_TG_GENERATE_IMAGES: string = `${this.BRIA_API}/tailored-generation/generation-endpoints/text-to-image-tailored`;
	public static readonly BRIA_API_TG_RESTYLE_PORTRAITS: string = `${this.BRIA_API}/tailored-generation/generation-endpoints/restyle-portrait`;
	//  Image Editing
	public static readonly BRIA_API_REMOVE_OBJECT: string = `${this.BRIA_API}/image-editing/endpoints/eraser`;
	public static readonly BRIA_API_BACKGROUND_REMOVE: string = `${this.BRIA_API}/image-editing/endpoints/background-remove`;
	public static readonly BRIA_API_BACKGROUND_GENERATION: string = `${this.BRIA_API}/image-editing/endpoints/background-replace`;
	public static readonly BRIA_API_BACKGROUND_BLUR: string = `${this.BRIA_API}/image-editing/endpoints/blur-bg`;
	public static readonly BRIA_API_IMAGE_EXPANSTION: string = `${this.BRIA_API}/image-editing/endpoints/image-expansion`;
	public static readonly BRIA_API_INCREASE_RESOLUTION: string = `${this.BRIA_API}/image-editing/endpoints/increase-resolution`;
	// Product Shot Editing
	public static readonly BRIA_API_TEXT_PROMPTS_LIFESTYLE: string = `${this.BRIA_API}/product-shot-editing/endpoints/product-lifestyle-shot-by-text`;
	public static readonly BRIA_API_LIFESTYLE_PRODUCT_SHOT_BY_IMAGE: string = `${this.BRIA_API}/product-shot-editing/endpoints/product-lifestyle-shot-by-image`;
	// Campaign
	public static readonly BRIA_API_GEN_FILL: string = `${this.BRIA_API}/image-editing/endpoints/gen-fill`;
	public static readonly BRIA_API_REFLECTIONS: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-generate-reflections`;
	public static readonly BRIA_API_EFFECTS: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-apply-effect`;
	public static readonly BRIA_API_HARMONIZATION: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-harmonize`;

	private static readonly BRIA_COMFYUI_GIT: string = "https://github.com/Bria-AI/ComfyUI-BRIA-API";
	public static readonly BRIA_API_V2: string = "https://docs.bria.ai/api_v2";

	public static readonly BRIA_COMFYUI = {
		GIT: this.BRIA_COMFYUI_GIT,
		README: {
			NODES: `${this.BRIA_COMFYUI_GIT}/blob/main/nodes`,
		},
		NODES: `${this.BRIA_COMFYUI_GIT}/tree/main/nodes`,
		WORKFLOWS: `${this.BRIA_COMFYUI_GIT}/tree/main/workflows`,
	};

	public static readonly HUGGING_FACE = "https://huggingface.co";

	public static readonly BRIA_BLOG = "https://blog.bria.ai";
	public static readonly KNOWLEDGE = {
		REMOVE_BG: `${this.BRIA_BLOG}/brias-new-state-of-the-art-remove-background-2.0-outperforms-the-competition`,
		ERASER: `${this.BRIA_BLOG}/elevate-your-teams-ai-image-editing-with-brias-eraser-0`,
	};
	public static readonly MODELS = {
		HUGGING_FACE: this.HUGGING_FACE,
		FOUNDATION: {
			"3_2": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.2`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.2-API`,
				},
			},
			"3_1": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.1`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.1`,
				},
			},
			"4B_ADAPT": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt`,
				},
			},
			"2_3": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-BETA`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3`,
				},
			},
			"2_2_HD": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.2-HD`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.2-HD`,
				},
			},
			"2_3_FAST": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-FAST`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-FAST`,
				},
			},
			"2_3_INPAINTING": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-Inpainting`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-Inpainting`,
				},
			},
		},
		AUXILIARY: {
			BRIA3_2_UNION: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.2-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.2-ControlNet-Union`,
				},
			},
			BRIA3_1_UNION: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.1-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.1-ControlNet-Union`,
				},
			},
			"4B_UNION": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-4B-Adapt-ControlNet-Union`,
				},
			},
			REMOVE_BG: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/RMBG-2.0`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-RMBG-2.0`,
				},
			},
			"2_3_FAST_LORA": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-FAST-LORA`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-FAST-LORA`,
				},
			},
			IMAGE_PROMPT: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/Image-Prompt`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/Image-Prompt`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/Image-Prompt`,
				},
			},
			IP_ADAPTER: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ID_Preservation#bria-23-id-preservation-adapter`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/ID_preservation_auraFace`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/ID_preservation_auraFace`,
				},
			},
			GEN_FILL: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Generative-Fill`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Generative-Fill-API`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Generative-Fill-API`,
				},
			},
			REPLACE_BG: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-BG-Gen`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Background-Generation`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Background-Generation`,
				},
			},
			INPAINTING: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
					DEMO: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
				},
			},
			CANNY: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
				},
			},
			DEPTH: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
				},
			},
			POSE: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Pose`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-ControlNet-Pose`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-ControlNet-Pose`,
				},
			},
			RECOLOR: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
					DOWNLOAD: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
				},
			},
			COLORGRID: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
				},
			},
			INCREASE_RES: {
				HUGGING_FACE: {},
			},
		},
	};

	public static readonly IMAGE_GENERATION = {
		OVERVIEW: `${this.BRIA_API}/image-generation`,
		BASE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-base`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_base_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		FAST: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-fast`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_fast_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		HD: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-hd`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_hd_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		REIMAGINE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/reimagine-structure-reference`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/reimagine_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_2_image_base_node.py`,
			},
		},
		VECTOR_BASE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-vector-base`,
		},
		VECTOR_FAST: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-vector-fast`,
		},
		PROMPT_ENHANCEMENT: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/prompt-enhancer`,
		},
	};

	public static readonly IMAGE_EDITING = {
		OVERVIEW: `${this.BRIA_API}/image-editing`,
		GEN_FILL: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/gen-fill`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/generative_fill_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		ERASER: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/eraser`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/eraser_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		ERASE_FOREGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/erase-foreground`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/remove_foreground_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		REPLACE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/background-replace`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/replace_bg_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		REMOVE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/background-remove`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/rmbg_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		BLUR_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/background-blur`,
		},
		EXPAND_IMAGE: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/image-expansion`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/image_expansion_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		INCREASE_RESOLUTION: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/increase-resolution`,
		},
		IMAGE_TO_PSD: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/image-to-psd`,
		},
		CROP: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/crop`,
		},
		MODIFY_PRESENTER: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/create`,
		},
		MASK_GENERATOR: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/objects-mask-generator`,
		},
		ENHANCE_IMAGE: {
			DOCS: `${this.BRIA_API}/image-editing/endpoints/enhance-image`,
		},
	};

	public static readonly TG = {
		OVERVIEW: `${this.BRIA_API}/tailored-generation`,
		CREATE_PROJECT: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/create-project`,
		},
		CREATE_DATASET: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/create-dataset`,
		},
		TRAINING: {
			DOCS: `${this.BRIA_API}/tailored-generation/section/training-process`,
		},
		TRAIN_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/section/training-endpoints/start-training`,
		},
		GENERATION: {
			DOCS: `${this.BRIA_API}/tailored-generation/generation-endpoints`,
		},
		GENERATE_IMAGES: {
			DOCS: `${this.BRIA_API}/tailored-generation/generation-endpoints/text-to-image-tailored`,
		},
		DOWNLOAD_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/download-tailored-model`,
		},
		UPLOAD_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/upload-model`,
		},
		RESTYLE_PORTRAITS: {
			DOCS: `${this.BRIA_API}/tailored-generation/generation-endpoints/restyle-portrait`,
		},
	};

	public static readonly ADS_GENERATION = {
		OVERVIEW: `${this.BRIA_API}/ad-generation`,
		GET_BRANDS: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-brands`,
		},
		GET_TEMPLATES: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-templates`,
		},
		GET_TEMPLATE: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-template-by-id`,
		},
		GENERATE_CAMPAIGN: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/generate-campaign`,
		},
	};

	public static readonly PRODUCT_SHOT = {
		OVERVIEW: `${this.BRIA_API}/product-shot-editing`,
		CUTOUT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-cutout`,
		},
		PACKSHOT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-packshot`,
		},
		ADD_SHADOW: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-shadow`,
		},
		LIFESTYLE_BY_TEXT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-lifestyle-shot-by-text`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/shot_by_text_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/product shot generation_workflow.json`,
			},
		},
		LIFESTYLE_BY_IMAGE: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-lifestyle-shot-by-image`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/shot_by_image_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/product shot generation_workflow.json`,
			},
		},
		BRANDING: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/consistent-product-shots`,
		},
		KEYWORD_EXTRACT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/contextual-keyword-extraction`,
		},
		AUTOMOTIVE: {
			HARMONIZATION: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/harmonization`,
			},
			REFLECTIONS: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-generate-reflections`,
			},
			SEGMENT_VEHICLE: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-segmentation`,
			},
			VEHICLE_BY_TEXT: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-shot-by-text`,
			},
			VISUAL_EFFECT: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-apply-effect`,
			},
			WHEELS: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-refine-tires`,
			},
		},
	};

	public static readonly VIDEO_EDITING = {
		REMOVE_BG: {
			DOCS: `${this.BRIA_API}/video-editing/endpoints/remove-video-background`,
		},
	};

	public static readonly INTEGRATIONS = {
		HUGGING_FACE: `${this.HUGGING_FACE}/briaai`,
		COMFY_UI: this.BRIA_COMFYUI_GIT,
		FAL: "https://fal.ai/models?keywords=bria",
		INVOKE: "https://www.invoke.com/",
		FIGMA: RouterConstants.NEW_TG.ACCESS_METHODS.fullPath,
		PHOTOSHOP: RouterConstants.NEW_TG.ACCESS_METHODS.fullPath,
		AWS: "https://aws.amazon.com/marketplace/seller-profile?id=seller-ilfk2fw5juhfi",
		AZURE: "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/briaartificialintelligenceltd1704805814390.bria_image_generation_model_offer?tab=Overview",
		COPILOT: "",
		POWERPOINT: "",
		CLAUDE: RouterConstants.IMAGE_EDITING.McpSERVER.fullPath,
		REPLICATE: "https://replicate.com/bria",
		MCP_GENERATION: RouterConstants.IMAGE_GENERATION.McpSERVER.fullPath,
		MCP_EDITING: RouterConstants.IMAGE_EDITING.McpSERVER.fullPath,
	};
	public static readonly BRIA_COOKBOOK: string = "https://bria.ai/bria-cookbook";
	public static readonly BRIA_MCP_SERVER_PROD: string = "https://mcp.prod.bria-api.com/mcp/sse";
	public static readonly BRIA_MCP_SERVER_INT: string = "https://mcp.int.bria-api.com/mcp/sse";
	public static readonly BRIA_MCP_CONTACT_URL: string = "https://bria.ai/contact-us?hsCtaAttrib=114250296256";

	public static readonly BRIA_CONTACT_US_MFA: string = "https://bria.ai/contact-us?interested_in=Support";

	public static readonly BRIA_CONTACT_US_FOUNDATION_MODELS =
		"https://bria.ai/contact-us?interested_in=Access%20to%20foundation%20models";
}

export default LinkConstants;
